import API from '@config/api';

const getNotifications = () => API.get('/notifications');
const createNotification = message => API.post(`/notifications`, {message});
const updateNotification = (id, message) => API.put(`/notifications/${id}`, {message});
const removeNotification = id => API.delete(`/notifications/${id}`);

export {getNotifications, createNotification, updateNotification, removeNotification};
